<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('eos_payment.index')">
        Pembayaran Akhir Studi
      </Link>
      <span class="font-medium text-indigo-400">/</span>
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('eos.edit', eosRecord.id)">
        {{ eosRecord.mahasiswa_name }} ({{ eosRecord.jenjang_pendidikan }})
      </Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ action === "CREATE" ? "Create" : "Edit" }}
    </h1>
    <trashed-message
      v-if="eosPayment.deleted_at"
      class="mb-6"
      @restore="restore">
      This record EosPayment has been deleted.
    </trashed-message>
    <div class="overflow-hidden w-full bg-white rounded-md shadow md:w-5/6">
      <form @submit.prevent="submit">
        <div class="flex flex-wrap py-4 px-8">
          <text-input
            :value="eosRecord.mahasiswa_name"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            input-class="bg-gray-200"
            label="Nama Mahasiswa"
            disabled />
          <div class="w-full" />
          <text-input
            :value="eosRecord.college_entry_year"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            input-class="bg-gray-200"
            label="Tahun Masuk Kuliah"
            disabled />
          <text-input
            :value="eosRecord.jenjang_pendidikan"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            input-class="bg-gray-200"
            label="Jenjang Pendidikan"
            disabled />
          <text-input
            :value="eosRecord.current_semester"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            input-class="bg-gray-200"
            label="Semester"
            disabled />
          <text-input
            :value="eosPayment.payment_num"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            placeholder="[AUTO GENERATED]"
            input-class="bg-gray-200 text-center"
            label="No Transaksi Bayar"
            disabled />
          <text-input
            v-model="form.bank_trans_num"
            :error="form.errors.bank_trans_num"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            label="No Transaksi Bank" />
          <text-input
            v-model="form.payment_date"
            v-mask="'##/##/####'"
            :error="form.errors.payment_date"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            input-class="text-center"
            label="Tanggal Transaksi"
            placeholder="dd/mm/yyyy" />
          <select-input
            v-model="form.scholarship_bank_id"
            :error="form.errors.scholarship_bank_id"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            label="Bank Tujuan">
            <option :value="null" disabled>
              Pilih Bank
            </option>
            <option
              v-for="bank in banks"
              :key="bank.id"
              :value="bank.id">
              {{ bank.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.scholarship_bank_acc_name"
            :error="form.errors.scholarship_bank_acc_name"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            label="Nama Pemilik Rekening" />
          <text-input
            v-model="form.scholarship_bank_acc_number"
            :error="form.errors.scholarship_bank_acc_number"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            label="No. Rekening Tujuan" />
          <file-input
            v-model="form.payment_file"
            :error="form.errors.payment_file"
            @preview="showModal('payment_file')"
            class="pb-4 md:pr-6 w-full md:w-2/3"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="Bukti Pembayaran (File)" />
          <text-input
            :value="eosRecord.graduation_year"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            placeholder="[FROM EOS RECORD]"
            input-class="bg-gray-200 text-center"
            label="Tahun Pembayaran (GRADYEAR)"
            disabled />
          <number-input
            v-model="form.payment_amount"
            :error="form.errors.payment_amount"
            class="pb-4 md:pr-6 w-full md:w-2/3"
            input-class="text-right"
            label="Jumlah Pembayaran" />
          <select-input
            v-model="form.bank_status_payment_id"
            :error="form.errors.bank_status_payment_id"
            class="pb-4 md:pr-6 w-full md:w-1/3"
            label="Status Pembayaran">
            <option disabled :value="null">
              Pilih Status
            </option>
            <option
              v-for="option in optionsStatusBayar"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select-input>
        </div>
        <div
          class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button
            :loading="form.processing"
            class="btn-green"
            type="submit">
            Simpan
          </loading-button>
        </div>
      </form>
    </div>
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        {{ modalTextHeader }}
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import NumberInput from '@/Shared/NumberInput'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'
import Swal from 'sweetalert2'
import { Link, useForm } from '@inertiajs/vue2'

export default {
  metaInfo () {
    return {
      title: 'Payment Akhir Studi',
    }
  },
  layout: Layout,
  components: {
    Link,
    TextInput,
    SelectInput,
    FileInput,
    LoadingButton,
    NumberInput,
    Modal,
    BlobImage,
  },
  props: {
    eosRecord: Object,
    eosPayment: Object,
    action: String,
    banks: Array,
    optionsStatusBayar: Array,
  },
  data () {
    return {
      imgUrl: null,
      isModalVisible: false,
      modalTextHeader: 'Hasil Scan',
      form: useForm({
        _method: 'put',
        ...this.eosPayment,
      }),
    }
  },
  methods: {
    showModal (docType) {
      this.imgUrl = `/preview/${this.eosPayment[docType]}`
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    submit () {
      Swal.fire({
        title: 'Konfirmasi',
        text: 'Apakah data pembayaran sudah sesuai?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.action === 'CREATE') this.store()
          if (this.action === 'EDIT') this.update()
        }
      })
    },
    store () {
      this.form._method = 'post'
      this.form.post(this.route('eos_payment.store'))
    },
    update () {
      this.form._method = 'put'
      if (typeof this.form.payment_file === 'string')
        this.form.payment_file = null
      this.form.post(this.route('eos_payment.update', this.eosPayment.id), {
        onSuccess: () => {
          this.form.payment_file = this.eosPayment.payment_file
        },
      })
    },
  },
}
</script>
